import z from "zod";
export const DTOCodeHistoryRepositoryFilter = z.object({
    repositoryName: z.string(),
    usagePackageNames: z.array(z.string()).optional(),
});
export const DTOCodeHistoryQuery = z.object({
    /** Filters components and usages by component package name (e.g. `@supernovaio/dm`) */
    packageNames: z.array(z.string()).optional(),
    /** Filters usages by component name (e.g. `Button`, `Icon`) */
    componentNames: z.array(z.string()).optional(),
    /**
     * Filters usages by repository and optionally by usage package within that repository.
     *
     * - `{"repositoryName": "cloud"}` — all usages for this repository (no package filter)
     * - `{"repositoryName": "cloud", "usagePackageNames": []}` — no usages for this repository
     * - `{"repositoryName": "cloud", "usagePackageNames": ["@supernovaio/portal"]}` — only matching packages for this repository
     */
    repositoryFilters: z.array(DTOCodeHistoryRepositoryFilter).optional(),
    /** Start of the time range filter (inclusive, ISO 8601 string) */
    timeFrameFrom: z.string().optional(),
    /** End of the time range filter (inclusive, ISO 8601 string) */
    timeFrameTo: z.string().optional(),
});
export const DTOCodeHistorySnapshot = z.object({
    scanId: z.string(),
    scanTimestamp: z.string(),
    totalComponents: z.number(),
    componentsWithUsage: z.string(),
    componentsWithStorybook: z.string(),
    totalUsages: z.string(),
});
export const DTOCodeHistoryResponse = z.object({
    snapshots: DTOCodeHistorySnapshot.array(),
});
